<template>
  <div class="modal-overlay postgame">
    <div class="modal-content">
      <img src="/static/images/sparkle_with_book2.png" class="image_half">

      <div class="modal-card">
        <div class="content">
          <div class="close-btn"><img src="/static/images/x.svg"/></div>

          <h1 class="top_title">{{ getTranslations.home_modals_post_game_great_results }}</h1>

          <p>{{ getTranslations.home_modals_post_game_finished_quiz }}</p>

          <div class="results_numb flex-row">
            <div class="flex-column">
              <h1>{{ postGameInfo.totalQuestions }}</h1>
              <p>{{ getTranslations.home_modals_post_game_questions }}</p>
            </div>

            <div class="divider_vert"></div>

            <div class="flex-column">
              <h1 class="correct">{{ postGameInfo.correctAnswers }}</h1>
              <p>{{ getTranslations.home_modals_post_game_correct }}</p>
            </div>

            <div class="divider_vert"></div>

            <div class="flex-column">
              <h1 class="wrong">{{ postGameInfo.wrongAnswers }}</h1>
              <p>{{ getTranslations.home_modals_post_game_wrong }}</p>
            </div>
          </div>

          <div class="points_and_ans">
            <div class="flex-column card">
              <div class="flex-row container answers">
                <div class="left flex-50">
                  <h1>{{ postGameInfo.correctAnswersPercent }}%</h1>
                </div>

                <div class="divider_vert"></div>

                <div class="right flex-column flex-50">
                  <h2>{{ getTranslations.home_modals_post_game_correct_answers }}</h2>
                </div>
              </div>
              <div class="flex-row container points selected">
                <div class="left flex-row flex-50">
                  <h1>+{{ postGameInfo.pointsEarned }}</h1>

                  <img src="/static/images/home/points_star.png">
                </div>
                <div class="divider_vert"></div>

                <div class="right flex-column flex-50">
                  <h2>{{ getTranslations.home_modals_post_game_points_earned }}</h2>

                  <p v-if="postGameInfo.remainingPointsToLevel > 0">
                    <span>{{ postGameInfo.remainingPointsToLevel }} {{ getTranslations.home_modals_post_game_points_for_next_level_pt1 }}</span>
                    {{ getTranslations.home_modals_post_game_points_for_next_level_pt2 }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="current_lvl">
            <p>{{ getTranslations.home_modals_post_game_current_level_pt1 }} <span>{{ getTranslations.home_modals_post_game_current_level_pt2 }} {{ postGameInfo.currentLevel }}</span></p>
          </div>

          <template v-if="hasGames">
            <base-button
              container-class="play"
              button-class="fancy_btn mini_text"
              @button:click="$emit('game:new')"
            >
              {{ getTranslations.home_modals_post_game_play_next_game_button_pt1 }}
              <span>{{ totalGames }} {{ isSingleGame ? getTranslations.home_modals_post_game_play_next_game_button_pt2 : getTranslations.home_modals_post_game_play_next_game_button_pt2_plural }}</span>
            </base-button>

            <div v-if="!hideStore" class="flex-row more_quizes_sect get_more_quiz_row"
                 @click="$emit('redirect:storePage')">
              <img src="/static/images/home/more_quizes_icon.svg">

              <p class="get_more_quiz">{{ getTranslations.home_modals_post_game_play_get_more_games_button }}</p>
            </div>
          </template>

          <template v-else-if="!hideStore">
            <base-button
              container-class="play"
              button-class="fancy_btn mini_text"
              @button:click="$emit('redirect:storePage')"
            >
              {{ getTranslations.home_modals_post_game_play_get_more_games_with_zero_games_left_button_pt1 }}
              <span>
                {{ getTranslations.home_modals_post_game_play_get_more_games_with_zero_games_left_button_pt2 }}
              </span>
            </base-button>
          </template>

          <template v-else>
            <base-button
              container-class="play"
              button-class="fancy_btn mini_text"
              @button:click="$emit('redirect:homePage')"
            >
              {{ getTranslations.home_modals_post_game_play_home_page_button }}
            </base-button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Howl} from 'howler'
import {mapGetters, mapState} from 'vuex'
import BaseButton from '../../../common/button/BaseButton'

export default {
  name: 'PostGameModal',
  components: {
    BaseButton
  },
  emits: [
    'game:new',
    'redirect:storePage',
    'redirect:homePage'
  ],
  props: {
    postGameInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      modalSound: new Howl({src: ['/static/sounds/postgame.mp3']})
    }
  },
  created () {
    if (localStorage.getItem('soundsOn') === 'true') {
      this.modalSound.play()
    }
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations'
    ]),
    ...mapState('common', [
      'hideStore'
    ]),
    totalGames () {
      return this.postGameInfo.availableGames
    },
    hasGames () {
      return this.totalGames > 0
    },
    isSingleGame () {
      return this.totalGames === 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/postgame/PostGameModal.vue